export default __webpack_public_path__ + "static/media/spark.2a2f0537.svg";